import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { getEnvVar } from 'shared/src/utils/env'
import cx from 'classnames'

import { sansSerifFontFamily } from 'utils/styles'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'

const TERMS_OF_SERVICE_PATH = '/terms-of-service'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#CBA67A',
    fontFamily: sansSerifFontFamily,
    fontSize: 12,
    paddingBottom: 15,
  },
  termsOfService: {
    color: '#CBA67A',
    textDecoration: 'none',
  },
})

interface Props {
  className?: string
}

export const TermsOfService: FC<Props> = flowMax(
  addDisplayName('TermsOfService'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ classes, className, t }) => (
    <div className={cx(classes.container, className)}>
      <Link
        to={getEnvVar('INFO_SITE_URL') + TERMS_OF_SERVICE_PATH}
        target="_blank"
        className={classes.termsOfService}
      >
        {t('termsOfService')}
      </Link>
      <div>{t('trademark')}</div>
    </div>
  )
)
